const tabGroups = document.querySelector(`.tabGroups`);
const tabInputs = tabGroups.querySelectorAll(`.tabGroups__tabInput`);
const tabGroupsSelect = tabGroups.querySelector(`.tabGroups__select`);

const tabGroupsSelectOnChange = (evt) => {
  tabInputs[tabGroupsSelect.selectedIndex].click();
};

tabGroupsSelect.addEventListener(`change`, tabGroupsSelectOnChange);